import React from 'react';
import { ScheduleTable } from '../../components/ScheduleTable';
import { LocationBlock } from '../../components/LocationBlock';
export function AfterSchoolScheduleLocation() {
  return <section className="py-24 bg-off-white" data-id="element-668">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-669">
        <div className="grid lg:grid-cols-2 gap-16" data-id="element-670">
          <div data-id="element-671">
            <h2 className="text-4xl text-ink mb-8" data-id="element-672">Class Times</h2>
            <ScheduleTable data-id="element-673" />
          </div>
          <div data-id="element-674">
            <h2 className="text-4xl text-ink mb-8" data-id="element-675">
              Taekwondo Classes in Farmington Hills, MI
            </h2>
            <LocationBlock data-id="element-676" />
          </div>
        </div>
      </div>
    </section>;
}